export default __webpack_public_path__ + "static/media/mo.3a3967f3.png";